import * as React from "react";

const CaskTypeSupplyPage: React.FC<{ children?: React.ReactNode }> = (
  props
) => <div>{props.children}</div>;

export default CaskTypeSupplyPage;
